var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"points-show"},[_c('el-col',{attrs:{"span":23}},[_vm._v(" 会员管理（开发中） ")]),_c('el-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }